<ion-row
  data-cy="'manage-users-list-row'"
  class="sortable-section-data-row"
  [ngClass]="user?.userId === currentUserId ? 'disabled' : 'active'"
  (click)="openUserExtendedView(user)"
>
  <ion-col data-cy="'manage-users-username-column'" size="2.25" offset="0.25">
    <p data-cy="'manage-users-username-text'">
      {{
        (user?.userName | slice: 0 : 20) +
          (user?.userName?.length > 20 ? '...' : '')
      }}
    </p>
  </ion-col>
  <ion-col size="1.50" offset="0.25" data-cy="manage-users-firstname-column">
    <p data-cy="'manage-users-firstname-text'">{{ user?.firstName || '-' }}</p>
  </ion-col>
  <ion-col size="1.50" offset="0.25" data-cy="manage-users-lastname-column">
    <p data-cy="'manage-users-lastname-text'">{{ user?.lastName || '-' }}</p>
  </ion-col>
  <ion-col size="2.25" offset="0.25" data-cy="manage-users-email-column">
    <p data-cy="'manage-users-email-text'">
      {{
        user?.email
          ? (user?.email | slice: 0 : 18) +
            (user?.email?.length > 18 ? '...' : '')
          : '-'
      }}
    </p>
  </ion-col>
  <ion-col size="1.50" offset="0.25" data-cy="manage-users-lastLogin-column">
    <p data-cy="'manage-users-lastLogin-text'">
      {{ (user?.lastLogin | date: 'M/d/yyyy' : 'GMT') || '-' }}
    </p>
  </ion-col>
  <ion-col
    class="manage-users-admin-badge"
    size="1"
    offset="0"
    data-cy="manage-users-admin-badge"
  >
    <img
      *ngIf="user?.admin === 'Y'"
      data-cy="'manage-users-admin-green-check'"
      src="assets/icon/green-circle-checkmark-admin-filled.svg"
    />
  </ion-col>
  <ion-col
    size="0.50"
    offset="0.25"
    data-cy="manage-user-ellipses"
    class="user-option-ellipses"
    (click)="$event.stopPropagation(); openUserOptions(user)"
  >
    <ion-icon
      *ngIf="user?.userId !== currentUserId"
      data-cy="'manage-user-info-list-options-icon'"
      name="ellipsis-vertical"
      size="small"
      [clickable]="true"
    ></ion-icon>
  </ion-col>
</ion-row>
